import { StudyCreationGuide } from './studyCreationGuide';
export default StudyCreationGuide;
